module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "sm12"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "color": _vm.err ? 'red' : 'green',
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_c('h6', [_vm._v(_vm._s(_vm.toolbarMessage))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "sm12"
  }, [_c('shdl-code-mirror', {
    ref: "editor",
    attrs: {
      "value": _vm.editedText,
      "readOnly": _vm.readOnly,
      "selectedline": _vm.selectedline,
      "styleactiveline": _vm.styleactiveline
    },
    on: {
      "change": _vm.codeChanged
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bd68874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shdl/ShdlEditor.vue
// module id = 1199
// module chunks = 1